import { CloudOff, RotateCw } from "lucide-react";
import { TapBoxButton, OUTLINE_RETRY_DRAWN_STYLE } from "./TapBoxButton";

/**
 * Issue #1217 — the drawn "failed to load" card, shared by the two record
 * screens that draw it: `EmptyRecord.dc.html:104` ("Couldn't load your
 * record") and `OneInnings.dc.html:138` ("Your career totals didn't load").
 * Both drawings are the same card: centred, a 44px icon tile with the
 * cloud-off glyph, title, help, then Try again. Same markup as
 * `RecordOneMatchScreen`'s `dash-recent-matches-error`.
 */
export default function RecordLoadFailedCard({ title, help, onRetry }) {
  return (
    <div
      data-testid="dash-summary-error"
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 6,
        padding: "20px 16px",
        background: "var(--nw-surface)",
        border: "1px solid var(--nw-line)",
        borderRadius: "var(--nw-radius-card)",
        textAlign: "center",
      }}
    >
      <div
        data-testid="dash-summary-error-icon"
        aria-hidden="true"
        style={{
          width: 44,
          height: 44,
          borderRadius: 14,
          background: "var(--nw-line-faint)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CloudOff size={20} style={{ color: "var(--nw-alert)" }} aria-hidden="true" />
      </div>
      <div style={{ fontWeight: 600, fontSize: 14, color: "var(--nw-ink)" }}>{title}</div>
      <div className="nw-help">{help}</div>
      {/* #1394 (D221 G4, D354): the 40px outlined button is drawn inside a transparent 44px tap box. */}
      <TapBoxButton
        data-testid="dash-summary-retry"
        onClick={onRetry}
        drawnStyle={OUTLINE_RETRY_DRAWN_STYLE}
        spaceAbove={6}
      >
        <RotateCw size={14} aria-hidden="true" />
        Try again
      </TapBoxButton>
    </div>
  );
}
